import { gql, useMutation } from '@apollo/client';
import { Obj } from '@livecontrol/core-utils';
import type { MutationResult } from '@livecontrol/scheduler/store';
import { Errors } from '@livecontrol/scheduler/store';
import { useCallback } from 'react';

const MUTATION = gql`
mutation CompleteMultipartAssetUpload($clientId: Int!, $assetId: Int!, $uploadId: String!, $parts: [PartInput!]!,) {
  CompleteMultipartAssetUpload(client_id: $clientId, asset_id: $assetId, upload_id: $uploadId, parts: $parts) {
    error
    message
    destination_url
  }
}
`;

interface TVariables {
    clientId: number;
    assetId: number;
    uploadId: string;
    parts: {part_number: number; e_tag: string}[];
}

interface TData {
    CompleteMultipartAssetUpload: {
        error?: boolean;
        message?: string;
        destination_url?: string;
    };
}

type Args = Partial<TVariables>;
type AssetReplace = TData['CompleteMultipartAssetUpload'];

export const useCompleteMultipart = (): [
    (args: Args) => Promise<AssetReplace | undefined>,
    MutationResult<AssetReplace>
] => {
    const [mutation, { loading, called, data }] = useMutation<TData, TVariables>(MUTATION);

    return [
        useCallback(async (args: Args) => {
            let data_: AssetReplace | undefined;

            try {

                if (!Obj.isHydrated(args)) {
                    throw Errors.badRequest();
                }

                const response = await mutation({ variables: args });

                data_ = response.data?.CompleteMultipartAssetUpload;
            } catch {
                //
            }

            return data_;
        }, [mutation]),
        {
            loading,
            called,
            data: data?.CompleteMultipartAssetUpload
        }
    ];
};
